<script lang="ts" setup>
import { useLocale } from '../composables/useLocale';

const { t } = useLocale();

withDefaults(
  defineProps<{
    isOpen: boolean;
    title: string;
    subtitle?: string;
    action?: () => void;
    actionLabel?: string;
    subtitleAction?: () => void;
  }>(),
  {
    isOpen: false,
  },
);
</script>

<template>
  <div v-if="isOpen" class="bottom-panel w-100">
    <v-row class="pa-6 ga-4 flex-nowrap align-center justify-space-between w-100" no-gutters>
      <v-col
        cols="auto"
        class="flex-1-1"
        :style="{ maxWidth: `calc(100% - ${action ? '200px' : '0'})`, minWidth: '60px' }"
      >
        <div class="text-truncate vertical-center text-subtitle-1 font-weight-bold">
          {{ title }}
        </div>
        <div v-if="subtitle && !subtitleAction" class="text-truncate">
          {{ subtitle }}
        </div>
        <div v-if="subtitle && subtitleAction" class="d-flex text-truncate">
          <v-btn
            variant="text"
            block
            color="primary"
            class="justify-start pa-0 ma-0 text-decoration-underline"
            height="24"
            @click.stop="subtitleAction"
          >
            <div class="text-truncate">
              {{ subtitle }}
            </div>
          </v-btn>
        </div>
      </v-col>

      <v-col v-if="action" cols="auto" class="flex-0-0">
        <v-btn @click="action" :aria-label="t(actionLabel || '')" append-icon="mdi-chevron-right">
          {{ actionLabel }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<style scoped lang="scss">
.bottom-panel {
  height: 76px;
  display: flex;
  align-items: center;
  border-top: 1px solid rgb(var(--v-theme-outline-variant));
}

// OMG Vuetify bug?
:deep(.v-btn__content) {
  max-width: 100%;
}
</style>
